import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  query,
  where,
  onSnapshot
} from 'firebase/firestore';
import { db } from '../utils/firebase';

// Helper to validate expense data
const validateExpense = (data) => {
  if (!data.userId) throw new Error('User ID is required');
  if (isNaN(data.amount)) throw new Error('Invalid amount');
  if (!(data.timestamp instanceof Date) || isNaN(data.timestamp)) throw new Error('Invalid date');
};

// Add a new expense
export const addExpenseService = async (userId, { amount, category, note, date, currency = 'INR' }) => {
  const expenseData = {
    amount: parseFloat(amount) || 0,
    category: category || 'Uncategorized',
    note: note || '',
    timestamp: date,
    currency: currency,
    createdAt: serverTimestamp(),
    userId: userId,
  };
  
  validateExpense(expenseData);
  const docRef = await addDoc(collection(db, 'expenses'), expenseData);
  return docRef.id;
};

// Update an existing expense
export const updateExpenseService = async (id, updatedData) => {
  const expenseRef = doc(db, 'expenses', id);
  await updateDoc(expenseRef, {
    ...updatedData,
    updatedAt: serverTimestamp(),
  });
};

// Delete an expense
export const deleteExpenseService = async (id) => {
  const expenseRef = doc(db, 'expenses', id);
  await deleteDoc(expenseRef);
};


// Subscribe to ALL expenses for a user (used by Reports/Search for instant access)
export const subscribeToAllExpenses = (userId, onUpdate, onError) => {
  if (!userId) {
    onUpdate([]);
    return () => {};
  }

  const expensesRef = collection(db, 'expenses');
  const q = query(
    expensesRef,
    where('userId', '==', userId)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    try {
      const expenses = snapshot.docs.map(doc => {
        const data = doc.data();
        let timestamp;
        if (data.timestamp?.toDate) {
          timestamp = data.timestamp.toDate();
        } else if (typeof data.timestamp === 'string') {
          timestamp = new Date(data.timestamp);
        } else {
          timestamp = data.createdAt?.toDate() || new Date();
        }
        
        return {
          id: doc.id,
          ...data,
          timestamp
        };
      });
      
      // Sort by timestamp descending
      expenses.sort((a, b) => b.timestamp - a.timestamp);
      
      onUpdate(expenses);
    } catch (err) {
      onError(err);
    }
  }, onError);

  return unsubscribe;
};
